import { useContext } from 'react'
import { OttOverlayContext } from '../providers'

export const useOttOverlay = () => {
  return useContext(OttOverlayContext)
}
